module.exports = __webpack_public_path__ + "fonts/montserrat-latin-200.2d8ba08.woff";